export default "/_next/static/images/design-real-room-card-1c1e59fcab17a79a5e933d97c4feeffe.png";